import React from 'react';

import { DialogContentText } from '@mui/material';

export const DiscountsMessage: React.FC = () => {
  return (
    <DialogContentText sx={{ fontSize: 15, color: '#000' }}>
      O parceiro deve conceder no mínimo 20% de desconto em pelo menos uma
      categoria de produto ou serviço.
    </DialogContentText>
  );
};

export default DiscountsMessage;

